import React from 'react';
import { useInteractiveDate } from 'domain/hooks/useInteractiveDate';
import { Date } from 'components/Input';

export const DateRange = ({
	startDate,
	endDate,
	setStartDate,
	setEndDate,
}: {
	startDate: string;
	endDate: string;
	setStartDate: (date: string) => void;
	setEndDate: (date: string) => void;
}) => {
	const startRef = React.createRef<HTMLInputElement>();
	const endRef = React.createRef<HTMLInputElement>();

	useInteractiveDate(startRef);
	useInteractiveDate(endRef);

	return (
		<div className={'flex flex-wrap justify-start gap-4'}>
			<Date date={startDate} setDate={setStartDate} ref={startRef} />
			<Date date={endDate} setDate={setEndDate} ref={endRef} />
		</div>
	);
};
